import { TablePagination } from '@mui/material';

import { useT } from '../i18n/LanguageContext';

type ServerPaginationProps = {
  /** Zero-based, as MUI counts. The API counts from one; the page converts. */
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
};

export const ServerPagination = ({ page, pageSize, total, onPageChange }: ServerPaginationProps) => {
  const t = useT();

  return (
    <TablePagination
      component="div"
      count={total}
      page={page}
      rowsPerPage={pageSize}
      rowsPerPageOptions={[pageSize]}
      onPageChange={(_event, next: number) => onPageChange(next)}
      labelDisplayedRows={({ from, to, count }) => t('pagination.range', { from, to, count })}
      // MUI's own button labels are English; a screen reader would read them to a Slovak user.
      getItemAriaLabel={(type) =>
        t(
          type === 'next'
            ? 'pagination.next'
            : type === 'previous'
              ? 'pagination.previous'
              : type === 'first'
                ? 'pagination.first'
                : 'pagination.last',
        )
      }
      labelRowsPerPage={t('pagination.rowsPerPage')}
    />
  );
};
